import { useEffect, useState } from "react";

// Default debounce window (ms) for search inputs across modules.
export const DEFAULT_DEBOUNCE_MS = 350;

/**
 * Returns a debounced copy of `value` that only updates after `delay` ms of
 * no changes. Replaces the ad-hoc setTimeout/clearTimeout debounce that was
 * scattered through the PNC and ShopManual search inputs.
 *
 * @param {*} value            the value to debounce (usually an input string)
 * @param {number} [delay]     debounce window in ms (default DEFAULT_DEBOUNCE_MS)
 * @returns {*}                the debounced value
 */
export default function useDebouncedValue(value, delay = DEFAULT_DEBOUNCE_MS) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}
